import React, { useState } from "react";
import classes from "./Header.module.scss";
import Tooltip from "@material-ui/core/Tooltip";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { useDispatch, useSelector } from "react-redux";
import { setPageTitle } from "../../actions";
import { BsGlobe2 } from "react-icons/bs";

const Language = () => {
  const pageTitle = useSelector((state) => state.pageTitle);
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [lang, setLang] = useState(i18n.language);

  function changeLanguage() {
    if (lang === "en") {
      setLang("fa");
    } else {
      setLang("en");
    }
    dispatch(setPageTitle(initialValue(pageTitle)));
    i18next.changeLanguage(lang === "en" ? "fa" : "en");
  }

  const initialValue = (title) => {
    if (title === "تراکنش ها" || title === "Transaction") {
      return lang !== "fa" ? "تراکنش ها" : "Transaction";
    }
    if (title === "گروه‌ها" || title === "Groups") {
      return lang !== "fa" ? "گروه‌ها" : "Groups";
    }
    if (title === "فاکتورها" || title === "Invoices") {
      return lang !== "fa" ? "فاکتورها" : "Invoices";
    }
    if (title === "دیسپچینگ" || title === "Dispatch") {
      return lang !== "fa" ? "دیسپچینگ" : "Dispatch";
    }
    if (title === "زیرمجموعه‌ها" || title === "Tenants") {
      return lang !== "fa" ? "زیرمجموعه‌ها" : "Tenants";
    }
    if (title === "پروفایل" || title === "profile") {
      return lang !== "fa" ? "پروفایل" : "profile";
    }
    if (title === "اعلان‌ها" || title === "Notifications") {
      return lang !== "fa" ? "اعلان‌ها" : "Notifications";
    }
    if (title === "گفتگوها" || title === "Chat") {
      return lang !== "fa" ? "گفتگوها" : "Chat";
    } else {
      return lang !== "fa" ? "کاربران" : "Users";
    }
  };

  return (
    <Tooltip title={t("header.change_site_language")} arrow placement="bottom">
      <div
        className={classes.showHeader}
        style={{ marginRight: "10px" }}
        onClick={() => changeLanguage()}
      >
        <div style={{ position: "relative" }} className={classes.headerButton}>
          <BsGlobe2
            className={classes.icons}
            style={{ margin: "1px", fontSize: "21px" }}
            fontSize={"small"}
          />
        </div>
      </div>
    </Tooltip>
  );
};

export default Language;
